import { ReactComponent as AfricaMapSvg } from '../assets/images/projects/africa-map.svg'

const AfricaMap = ({ className = '', highlightCountries = [] }) => {
  const countryRules = highlightCountries
    .map(
      (cls) => `
        .africa-map .${cls} {
          fill: #007DD6;
        }
        .africa-map .${cls}:hover {
          fill: #005bb5;
        }
      `
    )
    .join('\n')

  return (
    <div className={`africa-map ${className}`}>
      <style>{`
        .africa-map svg {
          width: 100%;
          height: 100%;
        }
        .africa-map .land {
          fill: #E6E6E6;
          stroke: #ffffff;
          stroke-width: 0.5;
          transition: fill 0.3s ease;
        }
        ${countryRules}
      `}</style>
      <AfricaMapSvg />
    </div>
  )
}

export default AfricaMap
